import React from "react";
import TelegramGroupList from "../../../UI/Groups/Telegram/View/TelegramGroupList";

const TelegramGroups = () => {
  return (
    <div>
      <TelegramGroupList />
    </div>
  );
};

export default React.memo(TelegramGroups);
